import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Paper,
  Box,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import {
  addApolloDiseaseDetection,
  addCodingApolloDiseaseDetection,
} from '../../api';

const PurpleTaskModal = ({ username, token, open, onClose, action, onSuccess }) => {
  const [apolloComment, setApolloComment] = useState('');
  const [diagnosisHCC, setDiagnosisHCC] = useState('');
  const [isApolloAdded, setIsApolloAdded] = useState(false);
  const [markAsResolved, setMarkAsResolved] = useState(false);

  useEffect(() => {
    if (action) {
      const hccString = `${action.diagnosis_code}/${action.hcc_code}`;
      setDiagnosisHCC(hccString);
    }
  }, [action]);

  const handleApolloCommentChange = (e) => setApolloComment(e.target.value);

  const handleSendToApollo = async () => {
    if (!action) return;
    const timestamp = Date.now().toString();
    const patientId = parseInt(action.patient_id);
    
    const finalComment = markAsResolved ? `Resolved - ${apolloComment}` : apolloComment;

    try {
      await addApolloDiseaseDetection(patientId, { username, token }, diagnosisHCC, finalComment, 'Clinical_Leadership', timestamp);
      await addCodingApolloDiseaseDetection(patientId, { username, token }, diagnosisHCC, finalComment, 'Clinical_Leadership', timestamp);
      setIsApolloAdded(true);
      
      // Close modal and refresh parent component
      setTimeout(() => {
        handleResetAndClose();
        if (onSuccess) {
          onSuccess();
        }
      }, 1000); // Small delay to show "Feedback Sent" message
      
    } catch (error) {
      console.error('Error submitting feedback:', error);
    }
  };

  const handleResetAndClose = () => {
    setApolloComment('');
    setDiagnosisHCC('');
    setIsApolloAdded(false);
    setMarkAsResolved(false);
    onClose();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Dialog
        open={open}
        onClose={handleResetAndClose}
        maxWidth={false}
        PaperProps={{ sx: { width: '600px' } }}
      >
        <DialogTitle>CDDC Feedback</DialogTitle>
        <DialogContent>
          {action ? (
            <>
              <Typography variant="body1"><strong>Patient ID:</strong> {parseInt(action.patient_id)}</Typography>
              <Typography variant="body1"><strong>Diagnosis:</strong> {action.diagnosis_code}</Typography>
              <Typography variant="body1" sx={{ mb: 2 }}><strong>HCC Code:</strong> {action.hcc_code}</Typography>

              <TextField
                variant="outlined"
                label="Diagnosis/HCC"
                value={diagnosisHCC}
                fullWidth
                disabled
                sx={{ mt: 2 }}
              />
              <TextField
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                label="Enter Comments"
                value={apolloComment}
                onChange={handleApolloCommentChange}
                sx={{ mt: 2 }}
              />
              {/* Hidden checkbox - keeping functionality but making it invisible */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={markAsResolved}
                    onChange={(e) => setMarkAsResolved(e.target.checked)}
                    name="markAsResolved"
                  />
                }
                label="Mark as resolved"
                sx={{ display: 'none' }}
              />
              <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleSendToApollo}
                  disabled={isApolloAdded}
                  sx={{ mt: 1 }}
                >
                  {isApolloAdded ? 'Feedback Sent' : 'Submit Feedback'}
                </Button>
              </Box>
            </>
          ) : (
            <Typography>No action selected</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResetAndClose} color="primary">Close</Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};

export default PurpleTaskModal;